<onyx-modal
  variant="right"
  [heading]="delegation()?.identifier"
  [loading]="loading()"
  [(error)]="error"
  [gap]="actionButton() ? 4 : 6"
  [close$]="close$"
  (errorChange)="delegation$.next()"
  (closeModal)="dialogRef.close()"
>
  <ng-container titleLeftOptions>
    @if (delegation()) {
      <onyx-icon name="delegation-filled" [size]="20"></onyx-icon>
    }
  </ng-container>

  <ng-container headingButtons>
    <onyx-icon-button
      variant="transparent"
      color="gray"
      [size]="32"
      icon="map-view-outlined"
      [circle]="true"
      onyxTooltip="labels.showOnMap"
      (click)="showOnMap()"
    ></onyx-icon-button>

    @if (delegation(); as delegation) {
      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="gantt-outlined"
        [circle]="true"
        onyxTooltip="labels.showOnGantt"
        (click)="showOnGantt()"
      ></onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="share-outlined"
        [circle]="true"
        onyxTooltip="labels.share"
        (click)="share()"
      ></onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="options-vertical-filled"
        [circle]="true"
        [disabled]="!options()?.length"
        [onyxDropdownOptions]="options()"
        [onyxDropdownDisabled]="!options()?.length"
        onyxDropdownMaxHeight="fill"
        (onyxDropdownSelectedValueChange)="$event.value?.()"
        onyxTooltip="labels.options"
        (click)="$event.stopPropagation()"
      ></onyx-icon-button>
    }
  </ng-container>

  <ng-container description>
    @if (delegation(); as delegation) {
      <app-delegation-modal-header-description
        [delegation]="delegation"
        [actionButton]="actionButton()"
      ></app-delegation-modal-header-description>
    }
  </ng-container>

  @if (delegation(); as delegation) {
    <div class="container">
      <div class="chips-container">
        <onyx-chips
          [chips]="SECTIONS"
          variant="tertiary"
          [single]="true"
          [wrap]="true"
          [gap]="8"
          [(activeValues)]="section"
        ></onyx-chips>

        @switch (section()[0]) {
          @case (DelegationModalSection.SUMMARY) {
            <app-delegation-modal-summary
              [delegation]="delegation"
              [close$]="close$"
            ></app-delegation-modal-summary>
          }
          @case (DelegationModalSection.NOTE) {
            <app-modal-note
              [note]="delegation.note"
              [route]="
                DelegationRoute.EDIT_DELEGATION.replace(
                  ':uuid',
                  delegation.uuid
                )
              "
              [close$]="close$"
            ></app-modal-note>
          }
        }
      </div>
    </div>
  }
</onyx-modal>
